import { CSSProperties } from "react";

const colors = {
  text: "#1a1c21",
  edge: "#4c4646",
  input: "#7ec8fc",
  tool: "#8db802",
  keep: "#e5f101",
  discardFill: "#f7f8d6",
  discardLine: "#9ca3af",
  discardInk: "#6b7280",
};

export const workflowDiagramStyles = {
  colors,
  shapes: {
    input: {
      backgroundColor: colors.input,
      borderRadius: 15,
    } satisfies CSSProperties,
    step: {
      backgroundColor: colors.tool,
      borderRadius: 2,
      border: "3px double",
    } satisfies CSSProperties,
    keep: {
      backgroundColor: colors.keep,
      borderRadius: 15,
      border: "2px solid rgba(26, 28, 33, 0.75)",
    } satisfies CSSProperties,
    discard: {
      backgroundColor: colors.discardFill,
      backgroundImage:
        "repeating-linear-gradient(135deg, rgba(0,0,0,0) 0 5px, rgba(0,0,0,0.07) 5px 7px)",
      border: `2px dashed ${colors.discardLine}`,
      color: colors.discardInk,
      borderRadius: 15,
    } satisfies CSSProperties,
  },
};
